<script>
import { Popup, Picker } from 'vant'
import ObjectFunc from '../../tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'picker-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-popup': Popup,
        'van-picker': Picker
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        id: String,
        label: String,
        options: Array,
        value: String,
        index: Number,
        keyword: String,
        popup: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            // selectedOptionLabel: null,
            selectedOption: null,
            selectedIndex: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        keywordLabel() {
            return this.getKeywordLabel()
        }
    },

    watch: {
        value(value) {
            // console.log('watch updated value setter', value, this.options, this.popup)
            this.updateValue(value)
        },
        popup(value) {
            this.showPopup = value
        }
    },

    mounted() {
        // console.log('mounted updated value setter', this.value, this.options, this.popup)
        this.updateValue(this.value)
        this.showPopup = this.popup
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onOptionPickerConfirm(data) {
            this.selectedOption = data
            this.showPopup = false
            if (this.id) {
                data.id = this.id
            }
            this.$emit('change-data', data)
        },
        onOptionPickerCancel() {
            this.showPopup = false
            this.selectedOption = null
            const data = {}
            if (this.id) {
                data.id = this.id
            }
            this.$emit('change-data', data)
        },
        getKeywordLabel() {
            return this.keyword ? this.keyword : 'label'
        },
        updateValue(value) {
            if (value == null) {
                this.selectedOption = null
                this.selectedIndex= null
                return
            }
            for (let i = 0; i < this.options.length; i++) {
                let option = this.options[i]
                if (option.value == value) {
                    this.selectedOption = ObjectFunc.cloneObject(option)
                    this.selectedIndex = i
                    return
                }
            }
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="picker-popup">
        <van-popup 
            v-model="showPopup" 
            position="bottom" 
            @click-overlay="onOptionPickerCancel"
        >
            <van-picker
                :title="label"
                :columns="options"
                :default-index="selectedIndex || index"
                :value-key="keywordLabel"
                show-toolbar
                @cancel="onOptionPickerCancel"
                @confirm="onOptionPickerConfirm"
            />
        </van-popup>
    </div>
</template>